import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import { ELEMENT_LABELS, ELEMENT_ICONS, ELEMENT_COLORS } from '../../common';

// Element advantage cycle (see BattleEngine::$elementBeats): each element
// beats exactly the next one in this list, wrapping around.
const ELEMENT_CYCLE = ['fire', 'wind', 'lightning', 'earth', 'water'];
export default class ElementsGuideModal extends Modal {
  className() {
    return 'ElementsGuideModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-cards"
    }), ' ', app.translator.trans('forumaker-arena.forum.elements_guide.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body ElementsGuideModal-body"
    }, m("p", {
      className: "ElementsGuideModal-intro"
    }, app.translator.trans('forumaker-arena.forum.elements_guide.intro')), m("ul", {
      className: "ElementsGuideModal-cycle"
    }, ELEMENT_CYCLE.map((el, i) => {
      const beaten = ELEMENT_CYCLE[(i + 1) % ELEMENT_CYCLE.length];
      return m("li", {
        key: el,
        className: "ElementsGuideModal-cycleRow"
      }, m("span", {
        className: "ElementsGuideModal-elementBadge",
        style: {
          '--arena-element-color': ELEMENT_COLORS[el]
        }
      }, m("i", {
        className: ELEMENT_ICONS[el]
      }), " ", ELEMENT_LABELS[el]), m("i", {
        className: "fas fa-long-arrow-alt-right ElementsGuideModal-arrow"
      }), m("span", {
        className: "ElementsGuideModal-elementBadge",
        style: {
          '--arena-element-color': ELEMENT_COLORS[beaten]
        }
      }, m("i", {
        className: ELEMENT_ICONS[beaten]
      }), " ", ELEMENT_LABELS[beaten]));
    })));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ElementsGuideModal', ElementsGuideModal);